import React from "react";
import MasterComponent from "../../../components/Forms";
import moment from "moment";
import { Avatar, Space } from "antd";
import { MasterConfigs } from "../../../interfaces/entity";

const ActiveClients = () => {

    const config: MasterConfigs = {
        api: () => '/external-leads',
        queryParams: { leadConverted: true },
        title: 'Contacts',
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                fixed: 'left',
                render: (text, record) => (
                    <Space direction='horizontal' className='contact_info'>
                        <Avatar src={`${process.env.FILE_URL}/files${record.profilePhoto}`} size={30} >
                            {record.profilePhoto ? '' : text.split(' ').map(e => e[0]).join('')}
                        </Avatar>
                        <div className="flex flex-col">
                            <a href={record?.linkedinProfile} target="_blank" rel="noopener noreferrer">
                                {record?.name}
                            </a>
                            <span className="text-gray-400">({record?.followers}){record?.position}</span>
                        </div>
                    </Space >
                ),
            },
            {
                width: 150,
                fixed: 'left',
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
            },
            {
                width: 150,
                fixed: 'left',
                title: 'Phone',
                dataIndex: 'phone',
                key: 'phone',
            },
            {
                title: 'Company',
                dataIndex: 'company',
                key: 'company',
                width: 150,
                ellipsis: true,
            },
            {
                title: 'Lead Type',
                dataIndex: 'LeadsTypes',
                key: 'LeadsTypes',
                width: 150,
                ellipsis: true,
                render: (text) => text ? text.name : 'N/A',
            },
            {
                title: 'Source',
                dataIndex: 'source',
                key: 'source',
                width: 100,
            },
            {
                title: 'Deal',
                dataIndex: 'leadConverted',
                key: 'leadConverted',
                align: 'center',
                width: 100,
                render: (text) => text ? 'Yes' : 'No',
            },
            {
                title: 'Location',
                dataIndex: 'locations',
                key: 'locations',
                width: 150,
                ellipsis: true,
            },
            {
                title: 'Website',
                dataIndex: 'website',
                key: 'website',
                width: 150,
                ellipsis: true,
            },
            {
                title: 'Connections',
                dataIndex: 'connections',
                key: 'connections',
                width: 150,
                ellipsis: true,
            },
            {
                title: 'Is Not Intrested',
                dataIndex: 'notIntrested',
                key: 'notIntrested',
                width: 150,
                render: (text) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Lead Brought By',
                dataIndex: 'createdBy',
                key: 'createdBy',
                fixed: 'right',
                render: (text) => text ? [text.firstName, text.lastName].join(' ') : 'N/A',
                width: 150,
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (text) => moment(text).format('DD MMM YYYY'),
                align: 'center',
                fixed: 'right',
                width: 150,
            },
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please input your name!' }],
            },
            {
                label: 'Position',
                name: 'position',
                type: 'text',
            },
            {
                label: 'Email',
                name: 'email',
                type: 'text',
            },
            {
                label: 'Phone',
                name: 'phone',
                type: 'text',
            },
            {
                label: 'Company',
                name: 'company',
                type: 'text',
            },
            {
                label: 'Website',
                name: 'website',
                type: 'text',
            },
            {
                label: 'Connections',
                name: 'connections',
                type: 'text',
            },
            {
                label: 'Location',
                name: 'locations',
                type: 'text',
            },
            {
                label: 'Lead Type',
                name: 'LeadsTypes',
                type: 'select',
                isCombo: true
            },
            {
                label: 'Source',
                name: 'source',
                type: 'text',
            },
            {
                label: 'Profile Link',
                name: 'linkedinProfile',
                type: 'text',
            },
            {
                span: 8
            },
            {
                label: 'Lead converted',
                dataIndex: 'leadConverted',
                name: 'leadConverted',
                type: 'checkbox',
            },
            {
                label: 'Is Not Intrested',
                dataIndex: 'notIntrested',
                name: 'notIntrested',
                type: 'checkbox',
            }
        ],
        combo: [
            {
                api: '/leads-types',
                name: 'LeadsTypes',
                idKey: '_id',
                render: (text) => text.name
            }
        ]
    }

    return (
        <MasterComponent config={config} />
    );
}

export default ActiveClients;